import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/publicaccount/list',
    method: 'get',
    params: query
  })
}

export function fetchPublicAccount(id) {
  return request({
    url: '/publicaccount/detail',
    method: 'get',
    params: { id }
  })
}

export function createPublicAccount(data) {
  return request({
    url: '/publicaccount/create',
    method: 'post',
    data
  })
}

export function updatePublicAccount(data) {
  return request({
    url: '/publicaccount/update',
    method: 'post',
    data
  })
}

export function delPublicAccount(data) {
  return request({
    url: '/publicaccount/del',
    method: 'post',
    data
  })
}

export function editStatus(data) {
  return request({
    url: '/publicaccount/status',
    method: 'post',
    data
  })
}

export function editIsMustAttention(data) {
  return request({
    url: '/publicaccount/ismustattention',
    method: 'post',
    data
  })
}

export function editSort(data) {
  return request({
    url: '/publicaccount/sort',
    method: 'post',
    data
  })
}

export function fetchAllList() {
  return request({
    url: '/publicaccount/alllist',
    method: 'get',
    params: {}
  })
}
